<!--
 * @Date: 2022-09-26 10:48:22
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-09 12:08:00
 * @description: description
-->
<template>
  <AboutusMobile v-if="isMobile" v-bind="{ info }" />
  <AboutusPc v-else v-bind="{ info }" />
</template>

<script>
import { mapState } from 'vuex'

import content from './content'

import AboutusPc from './aboutus.pc/Index.vue'
import AboutusMobile from './aboutus.mobile/Index.vue'

export default {
  name: 'coupon',
  components: {
    AboutusPc,
    AboutusMobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    info () {
      return content
    }
  },
  created () {

  },
  destroyed () {
  },
  methods: {

  }
}
</script>
